module.exports = __webpack_public_path__ + "media/assets/icons/noodle-bowl-b57ac5c54cbfa915ec12e4b5f088f059.svg";